import { default as React, useContext } from "react";


import { WithTranslation, withTranslation } from "react-i18next";
import Row from "./row";
import { CnecInfoDto } from "core/backend/data";
import { MultiSelectItem } from "components/multiselect";
import { keys } from "ts-transformer-keys";
import classNames from "classnames";

interface OwnProps {
    scrollPosition?: { left: number, top: number };
    data: CnecInfoDto[];
    hubs: MultiSelectItem[];
}

const List = ({ t, data, hubs, scrollPosition }: OwnProps & WithTranslation) => {
    const top = Math.max(0, ((scrollPosition?.top || 0) - 16));
    const left = Math.max(0, ((scrollPosition?.left || 0) - 16));

    const keysInDto = keys<CnecInfoDto>();
    const dtoHubs = hubs.filter((x) => keysInDto.some((key) => key.toLowerCase().endsWith(x.id.toLowerCase())));

    return (
        <table id="datatable">
            <thead>
                <tr>
                    <th className="fixedDateColumn fixedHeader" style={{ top: top + "px", left: left + "px" }}></th>
                    <th colSpan={5} className="tableTitles fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:infoCnec")}</th>
                    <th colSpan={4} className="tableTitles fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:infoContingency")}</th>
                    <th colSpan={3} className="tableTitles fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:infoSelection")}</th>
                    <th colSpan={3} className="tableTitles fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:maxCalcInfo")}</th>
                    <th colSpan={3} className="tableTitles fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:adjMinInfo")}</th>
                    <th colSpan={(dtoHubs.length * 2)} className="tableTitles fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:ptdfNtc")}</th>
                    <th colSpan={(dtoHubs.length * 2)} className="tableTitles fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:ptdfRef")}</th>
                    <th colSpan={5} className="tableTitles fixedHeader text-disabled" style={{ top: top + "px" }}>{t("ibwt_cnec:fbInfo")}</th>
                </tr>
                <tr>
                    <th className="fixedDateColumn" style={{ top: top + "px", left: left + "px" }}>{t("common:Date")}</th>

                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:cneName")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:cneEic")}</th>
                    <th className="fixedHeader text-disabled" style={{ top: top + "px" }}>{t("ibwt_cnec:direction")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:hubFrom")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:hubTo")}</th>

                    <th className="fixedHeader lineLeft" style={{ top: top + "px" }}>{t("ibwt_cnec:contingencyName")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:contEic")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:hubFrom")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:hubTo")}</th>

                    <th className="fixedHeader lineLeft" style={{ top: top + "px" }}>{t("ibwt_cnec:sensitivity")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:selected")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:limiting")}</th>

                    <th className="fixedHeader lineLeft" style={{ top: top + "px" }}>{t("ibwt_cnec:fmax")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:fref")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:fntc")}</th>

                    <th className="fixedHeader lineLeft" style={{ top: top + "px" }}>{t("ibwt_cnec:mncc")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:mccc")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("ibwt_cnec:totalMaczt")}</th>

                    {dtoHubs.map((hub, i) => <th key={hub.id} className={classNames("fixedHeader", i === 0 ? "lineLeft" : "")} style={{ top: top + "px" }}>{t("ibwt_cnec:ptdf_IT_" + hub.id)}</th>) /* Import */} 
                    {dtoHubs.map((hub, i) => <th key={hub.id} className={classNames("fixedHeader")} style={{ top: top + "px" }}>{t("ibwt_cnec:ptdf_" + hub.id + "_IT")}</th>) /* Export */} 
                    {dtoHubs.map((hub, i) => <th key={hub.id} className={classNames("fixedHeader", i === 0 ? "lineLeft" : "")} style={{ top: top + "px" }}>{t("ibwt_cnec:ptdf_IT_" + hub.id)}</th>) /* Import */}
                    {dtoHubs.map((hub, i) => <th key={hub.id} className={classNames("fixedHeader")} style={{ top: top + "px" }}>{t("ibwt_cnec:ptdf_" + hub.id + "_IT")}</th>) /* Export */}

                    <th className="fixedHeader lineLeft text-disabled" style={{ top: top + "px", whiteSpace: "nowrap" }}>{t("ibwt_cnec:frm")}</th>
                    <th className="fixedHeader text-disabled" style={{ top: top + "px" }}>{t("ibwt_cnec:ltn")}</th>
                    <th className="fixedHeader text-disabled" style={{ top: top + "px" }}>{t("ibwt_cnec:ram")}</th>
                    <th className="fixedHeader text-disabled" style={{ top: top + "px" }}>{t("ibwt_cnec:amr")}</th>
                    <th className="fixedHeader text-disabled" style={{ top: top + "px" }}>{t("ibwt_cnec:ltaMargin")}</th>
                </tr>
            </thead>
            <tbody>
                {
                    data && data.map((d) => <Row key={d.id} dto={d} hubs={dtoHubs} left={left} />)
                }
            </tbody>
        </table>
    );
};

const translated = withTranslation("ibwt_cnec")(List);

export default translated;